import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../../api/auth.api';
import { ProfileAvatarComponent } from '../profile-avatar';

@Component({
  selector: 'school-menuinfo-ui',
  templateUrl: './menuinfo-ui.component.html',
  styleUrls: ['./menuinfo-ui.component.scss']
})
export class MenuinfouiComponent {

  @Input() username: any;
  @Input() designation: any;
  @Input() userimg: any;
  @Input() signoutlink: any;

  constructor(
    private route: Router,
    private authService: AuthService,
    private dialog: MatDialog,
  ) { }

  signout() {
    this.authService.logout();
    this.route.navigate([this.signoutlink]);
  }

  render_desigination(data) {
    switch (data) {
      case 'Scancentre':
        return 'Scan Center';
        break;

      default:
        return data;
        break;
    }
  }


  editAvatar(): void {
    const dialogRef = this.dialog.open(ProfileAvatarComponent, {
      width: '650px',
      data: {
        message: 'Are you sure change to Avatar?',
        buttonText: {
          ok: 'Upload',
          cancel: 'Cancel'
        }
      }
    });
  }


}
